<template>
  <div id="app">
    <div id="nav">
      <component :is="layout">
        <router-view />
      </component>
    </div>
  </div>
</template>

<script>
import MainLayout from './components/Layouts/MainLayout.vue';
import FullScreenLayout from './components/Layouts/FullScreenLayout.vue';

export default {
  name: 'App',
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.isAuthenticated ? MainLayout : FullScreenLayout;
    },
    isAuthenticated() {
      return this.$authenticationInfo.isAuthenticated;
    },
  },
  mounted() {
    if (!this.isAuthenticated && this.$route.name !== this.$loginPage) {
      this.$router.replace({ name: this.$loginPage });
    } else if (this.isAuthenticated && this.$route.name === this.$loginPage) {
      this.$router.replace({ name: this.$landingPage });
    }
  },
  methods: {
    logout() {
      this.$logoutUser();
    },
  },
  components: {
    MainLayout,
    FullScreenLayout,
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/theme.scss';
</style>
